import { CompleteOperationType } from 'model/alerts.model';
import { ModalAction } from 'model/modal.model';
import { Dispatch } from 'react';
import { useNavigate } from 'react-router-dom';

export const useActionsHandlers = (
  dispatch: Dispatch<ModalAction>,
  completeOperation: CompleteOperationType,
) => {
  const navigate = useNavigate();

  const handleCopyLink = () => {
    completeOperation('create', 'Copied to clipboard');
    navigator.clipboard.writeText(window.location.href);
  };

  const handleDelete = () => {
    dispatch({ type: 'OPEN', payload: 'delete' });
  };

  const handleEdit = () => {
    navigate('edit');
  };

  return {
    copy: handleCopyLink,
    edit: handleEdit,
    delete: handleDelete,
  };
};
